import { render, staticRenderFns } from "./nayin.vue?vue&type=template&id=212ff808&scoped=true&"
import script from "./nayin.vue?vue&type=script&lang=js&"
export * from "./nayin.vue?vue&type=script&lang=js&"
import style0 from "./nayin.vue?vue&type=style&index=0&id=212ff808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ff808",
  null
  
)

export default component.exports